<template>
  <div class="map-view">
    <div class="flex">
      <el-input v-model="origin" placeholder="始发地" clearable @blur="changeIpt('1')"></el-input>
      <img src="https://minio.hxinsoft.com/jiayuan/20231219063003/4ae0587efc1648b59d559bb6df2347ef.png" class="cashIcon" @click="exchange" />
      <P></P>
      <el-input v-model="destination" placeholder="目的地" clearable @blur="changeIpt('2')"></el-input>
      <el-button @click="handelPlane" :loading="loading" style="margin-left: 20px;">查 询</el-button>
    </div>
    <!-- <div id="main" :style="{ height: pageHeight + 'px' }"></div> -->
    <div class="cityList">
      <div class="province" v-for="(item, index) in pcTextArr" :key="index">
        <div style="color: chocolate;white-space: nowrap;margin-right: 15px;">{{ item.label }}</div>
        <div v-for="(i, idx) in item.children" :key="idx" class="city_list" @click="checkCity(i)">{{ i.label }}</div>
      </div>
    </div>
    <div class="dialog">
      <el-dialog title="" center :visible.sync="show" :show-close="false">
        <div
          class="clist"
          v-for="(item, index) in businessList"
          :key="item.id"
          @click="handleShow(item, index)"
          v-loading="index == checkIdx && listLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(225, 225,225, 0.8)"
        >
          <div style="display:flex; align-items: center;">
            <img :src="item.logoUrl" class="pic" />
            <div class="text">
              <p>{{ item.name }}</p>
              <p>{{ item.address }}</p>
            </div>
          </div>
          <div style="display: flex;align-items: center;">
            <p class="text1" v-if="place.start && place.end">{{ place.start }}-{{ place.end }}（直达）</p>
            <img src="https://minio.hxinsoft.com/jiayuan/20231219063901/dd3f065971384dac8e8df4e5f1cb19f0.png" class="icon" />
          </div>
        </div>
        <div v-if="businessList.length == 0" class="empty">
          <img src="https://minio.hxinsoft.com/jiayuan/20231219093012/00587a4af8e74d77b33c8b62bc61c338.png" />
          <p>暂无相关内容</p>
        </div>
      </el-dialog>
    </div>
    <!-- 城市列表 -->
    <div class="city">
      <el-dialog title="" center :visible.sync="cityShow" :show-close="false">
        <div class="list">
          <div class="cityName" v-for="(item, index) in cityList" :key="index" @click="checkCity(item)">{{ item.label }}</div>
        </div>
      </el-dialog>
    </div>
    <div class="miniQrShowDio">
      <el-dialog title="微信扫码 一键拨号" :visible.sync="miniQrShow" center :show-close="false">
        <div style="display: flex;justify-content: center;">
          <img :src="miniQr" class="img" />
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import geoJson from "echarts/map/json/china";
import { pcTextArr } from "element-china-area-data";
import axios from "axios";
const instance = axios.create();
instance.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
export default {
  data() {
    return {
      proList: [],
      pcTextArr,
      origin: "",
      destination: "",
      show: false,
      cityShow: false,
      businessList: [],
      inputIdx: 0,
      loading: false,
      cityList: [],
      place: {
        current: 0,
        end: "",
        searchtext: "{}",
        size: 10,
        start: "",
      },
      listLoading: false,
      checkIdx: 0,
      miniQrShow: false,
      miniQr: "",
    };
  },
  computed: {
    pageHeight: function() {
      return document.documentElement.clientHeight - 150;
    },
  },
  mounted() {
    let that = this;
    let myChart = this.$echarts.init(document.getElementById("main"));
    // 注册的是中国地图，必须包括geo组件或者mep图标类型的时候才可以使用
    // 地图：世界地图，中国地图，省份地图，市区地图
    this.$echarts.registerMap("china", geoJson);
    myChart.setOption({
      // 背景色
      backgroundColor: "rgb(255,255,255)",
      // 配置项(组件)
      geo: {
        map: "china",
        // 地图的长宽比例
        aspectScale: 0.75,
        // 图层
        zoom: 1.1,
        // 样式
        itemStyle: {
          // 标准
          normal: {
            // 地图区域的颜色
            areaColor: {
              type: "radial",
              x: 0.5,
              y: 0.5,
              r: 0.8,
              // 颜色的步骤
              colorStops: [
                {
                  offset: 0,
                  color: "#09132c",
                },
                {
                  offset: 1,
                  color: "#274d68",
                },
              ],
              // 延长作用域
              globalCoord: true,
            },
            // 盒子的阴影
            shadowColor: "rgb(58,115,192)",
            // 偏移
            shadowOffsetX: 10,
            shadowOffsetY: 11,
          },
        },
        region: [
          {
            name: "南海诸岛",
            itemStyle: {
              opacity: 0,
            },
          },
        ],
      },
      series: [
        // 配置地图相关的数据参数
        {
          type: "map",
          label: {
            normal: {
              // 显示文字
              show: true,
              textStyle: {
                color: "#000000",
              },
            },
            emphasis: {
              textStyle: {
                color: "rgb(255,255,255)",
              },
              label: {
                show: true,
              },
            },
          },

          // 图层
          zoom: 1.1,
          map: "china",
          itemStyle: {
            normal: {
              // 背景色
              backgroundColor: "rgb(255,255,255)",
              // 边框
              borderWidth: 1,
              // 区域颜色
              areaColor: {
                type: "radial",
                x: 0.5,
                y: 0.5,
                // 文档
                r: 0.8,
                colorStops: [{ offset: 0, color: "rgb(255,255,255)" }, { offset: 1, color: "rgb(255,255,255)" }],
                // 全局生效
                globalCoord: true,
              },
            },
            // 高亮效果
            emphasis: {
              areaColor: "rgb(69,139,0)",
              borderWidth: 0.1,
            },
          },
        },
      ],
    });
    myChart.on("click", function(params) {
      that.getCity(params.name);
    });
    pcTextArr.forEach((ele) => {
      if (ele.label.indexOf("省") == -1) {
        ele.children.unshift({
          label: ele.label,
          value: ele.value,
        });
      }
    });
  },
  methods: {
    exchange() {
      if (this.origin && this.destination) {
        [this.origin, this.destination] = [this.destination, this.origin];
      }
    },
    getCity(val) {
      this.cityList = [];
      this.pcTextArr.forEach((ele) => {
        if (ele.label.indexOf(val) != -1) {
          this.cityList = ele.children;
          if (this.cityList.length > 0) {
            this.cityShow = true;
          }
        }
      });
    },
    checkCity(e) {
      if (this.inputIdx == 1) {
        this.origin = e.label;
      } else if (this.inputIdx == 2) {
        this.destination = e.label;
      } else if (this.inputIdx == 0 && !this.origin) {
        this.origin = e.label;
      } else if (this.inputIdx == 0 && !this.destination) {
        this.destination = e.label;
      }
      this.cityShow = false;
    },
    changeIpt(e) {
      this.inputIdx = e;
    },
    removeChars(str, char1, char2) {
      const pattern = new RegExp(`[${char1}${char2}]`, "gi");
      return str.replace(pattern, "");
    },
    handelPlane() {
      this.loading = true;
      this.place.start=this.removeChars(this.origin,'市','区')
      this.place.end=this.removeChars(this.destination,'市','区')
      this.$http.post("https://cloud.hxinsoft.com/hxinsoft-api/api/cmsline/getlist", this.place).then((res) => {
        if (res.data.code == "000000") {
          this.show = true;
          this.loading = false;
          res.data.data.forEach((ele) => {
            console.log(ele);
            if (JSON.parse(ele.logo)) {
              ele.logoUrl = "https://yunliantest.oss-cn-beijing.aliyuncs.com/" + JSON.parse(ele.logo).thirdUrl;
            } else {
              ele.logoUrl = "https://minio.hxinsoft.com/jiayuan/20231219061500/584ed5308b794a2ba1ef55fd0d925784.png";
            }
          });
          this.businessList = res.data.data;
          this.businessList.forEach((e) => {
            if (e.logoUrl.indexOf("undefined") != -1) {
              e.logoUrl = "https://minio.hxinsoft.com/jiayuan/20231219061500/584ed5308b794a2ba1ef55fd0d925784.png";
            }
          });
        }
      });
    },
    handleShow(e, index) {
      this.listLoading = true;
      this.checkIdx = index;
      instance
        .post(
          "https://cloud.hxinsoft.com/hxinsoft-wuliu/cmscompany/getCompanyCode",
          { id: e.id },
          {
            headers: {
              "client-type": "WULIU",
            },
          }
        )
        .then((res) => {
          if (res.data.code == "000000") {
            this.miniQrShow = true;
            this.listLoading = false;
            this.miniQr = "https://yunliantest.oss-cn-beijing.aliyuncs.com/" + res.data.data;
          } else {
            this.miniQrShow = true;
            this.listLoading = false;
            this.miniQr = "https://minio.hxinsoft.com/jiayuan/20231221053837/fcf29009521f49c7b59f3ca23878d472.jpg";
          }
        });
    },
  },
};
</script>

<style scoped>
.map-view {
  width: 100%;
  position: relative;
}
#main {
  width: 100%;
  height: 850px;
}
.cashIcon {
  width: 30px;
  margin: 0 15px;
  vertical-align: -10px;
  cursor: pointer;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  padding-top: 50px;
  width: 100%;
}
::v-deep .el-input {
  width: 400px !important;
}
.cityName {
  /* width: 100px; */
  height: 50px;
  border: 1px solid #f1f1f1;
  border-radius: 10px;
  text-align: center;
  line-height: 50px;
  font-size: 18px;
  color: #000;
  margin: 5px;
  cursor: pointer;
  padding: 0 20px;
}
.cityName:hover {
  color: rgb(69, 139, 0);
  background: rgba(69, 139, 0, 0.1);
  border: 1px solid #458b00;
}
.list {
  display: flex;
  flex-wrap: wrap;
}
.clist {
  border-bottom: 1px solid #ebeef5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.pic {
  width: 60px;
  height: 60px;
}
.text {
  margin-left: 10px;
  font-size: 14px;
}
.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 120px;
  font-size: 14px;
}
.icon {
  width: 30px;
  height: 30px;
  margin-right: 10px;
  cursor: pointer;
}
.miniQrShowDio ::v-deep .el-dialog {
  margin-top: 30vh !important;
  height: 350px;
  border-radius: 20px;
  width: 20%;
}
.img {
  width: 200px;
  height: 200px;
}
.dialog ::v-deep .el-dialog {
  width: 50%;
  border-radius: 10px;
  overflow: hidden;
  overflow-y: auto;
  height: 600px;
}
::v-deep .el-dialog::-webkit-scrollbar {
  width: 0; /* 隐藏滚动条 */
}
.cityList {
  cursor: pointer;
  font-size: 12px;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  top: 120px;
}
.city_list {
  padding: 5px;
  /* margin-left: 15px; */
}
.city_list:hover {
  color: chocolate;
}
.province {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 430px) {
  .slider_img {
    height: 65px;
    width: 100%;
  }
  ::v-deep .el-dialog::-webkit-scrollbar {
    width: 0; /* 隐藏滚动条 */
  }
  .dialog ::v-deep .el-dialog {
    width: 90%;
  }

  .miniQrShowDio ::v-deep .el-dialog {
    width: 80%;
  }
  .city ::v-deep .el-dialog {
    width: 80%;
  }
}
</style>
